import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "Attachment";
var classes = {
    selection: "".concat(PREFIX, "-selection"),
    selectionButton: "".concat(PREFIX, "-selectionButton"),
    title: "".concat(PREFIX, "-title"),
    description: "".concat(PREFIX, "-description"),
    meta: "".concat(PREFIX, "-meta"),
    actions: "".concat(PREFIX, "-actions"),
    action: "".concat(PREFIX, "-action"),
    metaItem: "".concat(PREFIX, "-metaItem")
};
var StyledAttachment = styled(Box)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            background: theme.palette.background.paper,
            borderRadius: theme.shape.borderRadius,
            border: "1px solid ".concat(theme.palette.grey[300]),
            padding: theme.spacing(1),
            display: "grid",
            gridTemplateAreas: "\"selection title title\" \"selection description description\" \"selection meta actions\" ",
            gridTemplateColumns: "min-content 1fr max-content",
            gap: theme.spacing(0.5),
            width: "100%",
            textAlign: "left",
            boxSizing: "border-box"
        },
        _b["& .".concat(classes.selection)] = {
            gridArea: "selection",
            padding: "0 ".concat(theme.spacing(1.5)),
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        _b["& .".concat(classes.selectionButton)] = {
            position: "initial"
        },
        _b["& .".concat(classes.title)] = {
            gridArea: "title",
            color: theme.palette.text.primary
        },
        _b["& .".concat(classes.description)] = {
            gridArea: "description",
            textOverflow: "ellipsis",
            overflow: "hidden",
            maxWidth: "70vh",
            color: theme.palette.text.primary
        },
        _b["& .".concat(classes.meta)] = {
            gridArea: "meta",
            listStyle: "none",
            padding: 0,
            margin: 0,
            display: "grid",
            gridAutoFlow: "column",
            gap: theme.spacing(1),
            gridTemplateColumns: "max-content"
        },
        _b["& .".concat(classes.actions)] = {
            gridArea: "actions",
            display: "flex",
            alignItems: "flex-end",
            justifyContent: "flexh-end",
            gap: theme.spacing(1)
        },
        _b["& .".concat(classes.action)] = {
            color: theme.palette.primary.main,
            textDecoration: "underline",
            padding: theme.spacing(1),
            margin: theme.spacing(-1, -0.5)
        },
        _b["& .".concat(classes.metaItem)] = {},
        _b);
});

export { StyledAttachment, classes, StyledAttachment as default };
//# sourceMappingURL=index.styled.js.map
